import { createSelector } from "@reduxjs/toolkit";
export const selectStudentIsLoggedIn = (state) =>
  Boolean(state.authStudent.studentToken);

export const selectStudentAuthError = (state) => state.authStudent.studentError;

export const selectStudentAccessToken = (state) =>
  state.authStudent.studentToken;

export const selectStudentAuthLoading = (state) =>
  state.authStudent.studentLoading;

export const selectStudentIsRefreshing = (state) =>
  state.authStudent.studentIsRefreshing;

export const selectStudentRefreshToken = (state) =>
  state.authStudent.studentRefreshToken;

export const selectStudentIsRefreshingSession = (state) =>
  state.authStudent.studentIsRefreshingSession;

const selectAuthStudent = (state) => state.authStudent;
const selectAuthTeacher = (state) => state.authTeacher;

export const selectCurrentUser = createSelector(
  [selectAuthStudent, selectAuthTeacher],
  (authStudent, authTeacher) => {
    const student = authStudent?.studentData;
    const teacher = authTeacher?.teacherData;

    if (student && authStudent?.studentToken) {
      return {
        id: student.id,
        name: student.name,
        role: "student",
        token: authStudent.studentToken,
      };
    }

    if (teacher && authTeacher?.teacherToken) {
      return {
        id: teacher.id,
        name: teacher.name,
        role: "teacher",
        token: authTeacher.teacherToken,
      };
    }

    return null;
  }
);

export const selectUserRole = createSelector(
  [
    (state) => state.authStudent.studentToken,
    (state) => state.authTeacher.teacherToken,
  ],
  (studentToken, teacherToken) => {
    if (studentToken) return "student";
    if (teacherToken) return "teacher";
    return null;
  }
);
